import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinNegara = createAsyncThunk(
    "negara/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+'Master/Negara/min',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getNegara = createAsyncThunk(
    "negara/get",
    async ({start, count, search}, thunkAPI) => {
        const params = {"start": start, "count": count, "search": search}
        const config = {
            headers: {'Authorization': `Bearer ` + user.Token},
            params: params,
        };
        try {
            const {data} = await axios.get(process.env.REACT_APP_API_URL+"Master/Negara", config)
            if (data.status === "Success") {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertNegara = createAsyncThunk(
    "negara/insert",
    async (param, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'Master/Negara',
                param,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateNegara = createAsyncThunk(
    "negara/update",
    async (params, thunkAPI) => {
        try {
            const response = await axios.put(
                process.env.REACT_APP_API_URL+'Master/Negara',
                params,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const negaraSlice = createSlice({
    name: "negara",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinNegara.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinNegara.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinNegara.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getNegara.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getNegara.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getNegara.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertNegara.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertNegara.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertNegara.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateNegara.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateNegara.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateNegara.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const negaraSelector = (state) => state.negara;
